import React from 'react';

const LoadingButton = ({text}) => {
    return (
        <button className="btn btn-ghost loading">{text}</button>
    );
};

export default LoadingButton;